export default __webpack_public_path__ + "static/media/gallery_03.38f5aeca.jpg";